export default __webpack_public_path__ + "static/media/coins.aae71316.png";